import React from 'react';
import { Button, notification, Form, type FormProps, Input, Card,InputNumber, Upload } from 'antd';
import { RewardService } from '../../services/RewardService';


interface Props {
    record: any
    onFinish: () => void
}

export default function Create(props: Props) {

    const [form] = Form.useForm();


    React.useEffect(() => {
        form.resetFields();
        form.setFieldsValue({
            ...props?.record,
        })

    }, [props?.record])



    const onFinish: FormProps["onFinish"] = async (values) => {






        if (props?.record?.id) {
            var res = await RewardService.updateTopup(values, props.record.id)
        } else {
            var res = await RewardService.saveTopup(values)
            form.resetFields();
        }

        if (res?.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            if (!props?.record?.id) {
                form.resetFields();
            }
            props.onFinish();
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    };

    const onFinishFailed: FormProps["onFinishFailed"] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    return (
        <Card
            bordered={false}>

            <Form
                name="basic"
                form={form}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                initialValues={{
                    points: 0,
                    reason: '',
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >


                {
                    !props.record.id ?
                        <Form.Item
                            label="Phone Number"
                            name="mobile_no"
                            extra="Ex. 6693334444"
                            rules={[{ required: true, message: 'Please fill phone number' }]}
                        >
                            <Input style={{width: 150}} />
                        </Form.Item>

                        :
                        null
                }

                <Form.Item
                    label="Points"
                    name="points"
                    rules={[{ required: true, message: 'Please fill points' }]}
                >
                    <InputNumber min={0} max={1000000} />
                </Form.Item>

                <Form.Item
                    label="Reason"
                    name="reason"
                    rules={[{ required: true, message: 'Please fill reason' }]}
                >
                    <Input />
                </Form.Item>




                <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                    <Button type="primary" htmlType="submit">
                        {props.record?.id ? 'อัพเดต' : 'บันทึก'}
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}
